import { format, parseISO } from 'date-fns'

export const fmt = {
  dt:    (iso: string) => format(parseISO(iso), 'dd MMM HH:mm'),
  date:  (iso: string) => format(parseISO(iso), 'dd MMM yyyy'),
  time:  (iso: string) => format(parseISO(iso), 'HH:mm'),
  num:   (n: number | null | undefined, decimals = 2) =>
    n == null ? '—' : n.toFixed(decimals),
  pct:   (n: number | null | undefined) =>
    n == null ? '—' : `${n.toFixed(1)}%`,
}

export const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export const CHART_COLORS = {
  blue:    '#2563EB',
  emerald: '#059669',
  amber:   '#D97706',
  red:     '#DC2626',
  violet:  '#7C3AED',
  cyan:    '#0891B2',
  slate:   '#64748B',
  grid:    '#E2E8F0',   // light gray grid lines for white background
  tooltip: '#1E293B',
}

export const severityColor = (s: string) => ({
  normal:   CHART_COLORS.slate,
  warning:  CHART_COLORS.amber,
  critical: CHART_COLORS.red,
}[s] ?? CHART_COLORS.slate)
